/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * リリース区分(1:下書き/2:即時配信/3:予約配信)
 * @export
 * @enum {string}
 */
export enum ReleaseSendKbn {
    DRAFT = 1,
    IMMEDIATE = 2,
    RESERVATION = 3
}

export function ReleaseSendKbnFromJSON(json: any): ReleaseSendKbn {
    return ReleaseSendKbnFromJSONTyped(json, false);
}

export function ReleaseSendKbnFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReleaseSendKbn {
    return json as ReleaseSendKbn;
}

export function ReleaseSendKbnToJSON(value?: ReleaseSendKbn | null): any {
    return value as any;
}

